import styled from '@emotion/styled';

type FilledTextValueDivProps = {
	fontSize: number;
	isMultiline?: boolean;
};

export const StyledComponentContentWrapper = styled.div<{
	left: number;
	top: number;
	width: number;
	height: number;
	transparent?: boolean;
}>`
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	border: none;

	left: ${props => props.left}px;
	top: ${props => props.top}px;
	width: ${props => props.width}px;
	height: ${props => props.height}px;

	${props => !props.transparent && 'background-color: #ededfd;'}
`;

export const StyledFilledTextValueDiv = styled.div<FilledTextValueDivProps>(props => ({
	fontSize: props.fontSize,
	fontFamily: 'Courier',
	wordBreak: props.isMultiline ? 'break-word' : 'normal',
	justifyContent: 'flex-start',
	height: '100%',
	width: '100%',
	lineHeight: 1.25,
	whiteSpace: 'pre-line',
}));
